export default __webpack_public_path__ + "static/media/ehs.a54ac341.svg";